import images from "@assets/images";
import { useAppSelector } from "@src/ducks/ducksHook";
import { selectResetPasswordSuccess } from "@src/ducks/slices/forgot.slice";
import React from "react";
import { ImageBackground } from "react-native";
import ResetPassword from "./ResetPassword";
import Success from "./Success";
import useStyles from "./styles.css";

const Forgot = () => {
  const styles = useStyles();
  const isResetPasswordSuccess = useAppSelector(selectResetPasswordSuccess);

  return (
    <ImageBackground
      source={{uri: images["gamezone-bg"]}}
      style={[styles.container]}
      resizeMode="stretch"
    >
      {isResetPasswordSuccess ? <Success /> : <ResetPassword />}
    </ImageBackground>
  );
};

export default Forgot;
